import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import { categories } from "@/mocks/categories";

export default function LatestArticles() {
  const latest = articles.slice(3);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
          最新内容
        </h2>
        <p className="text-sm text-foreground-600 max-w-lg mx-auto">
          持续更新，不错过任何精彩
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {latest.map((article) => {
          const cat = categories.find((c) => c.id === article.categoryId);
          return (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-accent-200 transition-colors cursor-pointer"
              data-product-shop=""
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={`${article.title} - 17c一起草国`}
                />
              </div>
              <div className="p-5">
                {cat && (
                  <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 font-medium mb-2 inline-block">
                    {cat.name}
                  </span>
                )}
                <h3 className="text-base font-semibold text-foreground-950 mb-2 mt-2 group-hover:text-accent-500 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>{article.author}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line" />
                    {article.viewCount.toLocaleString()}
                  </span>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}